import React from 'react'
import { Icon } from '../Icon'
import { ShowIf } from '../ShowIf'

export type TabTitleProps = {
  title: string
  /** The icon to show before the title; without it the title renders text only. */
  icon?: string
}

// The title of a `Tab`: its icon, then its text.
export const TabTitle = ({ title, icon }: TabTitleProps) => (
  <>
    <ShowIf condition={!!icon}>
      <Icon name={icon} className="me-1" aria-hidden="true" />
    </ShowIf>
    {title}
  </>
)
